// Authentic guest reviews from Royal Garden Villas.
// Sourced from real WhatsApp guest feedback (May 2026) — names cleaned/anonymised
// where the source only had partial first names. Used for the Testimonials
// section on the homepage and for the Review + AggregateRating JSON-LD schema.

export const reviews = [
  {
    name: 'Urvi S.',
    rating: 5,
    date: '2024-01-20',
    text: 'Absolute delight! Very well maintained. Swimming pool was also very clean. Mattresses are super cool for comfort. Highly recommended.',
    occasion: 'Family Stay',
  },
  {
    name: 'Lalit Kumar Rajput',
    rating: 5,
    date: '2024-02-07',
    text: 'Thank you for hosting us. We loved the property a lot, especially the garden area and the beautiful rooms and living room.',
    occasion: 'Family Stay',
  },
  {
    name: 'Aniket',
    rating: 5,
    date: '2024-03-04',
    text: 'We had a wonderful time at your villa. Everything was set up beautifully and the property is well kept.',
    occasion: 'Group Weekend',
  },
  {
    name: 'Omkar Mali',
    rating: 5,
    date: '2024-06-03',
    text: 'The stay was awesome — happy to come again sometime. Smooth check-in, helpful staff, and the deposit refund was processed quickly.',
    occasion: 'Family Stay',
  },
  {
    name: 'Royal Garden Guests',
    rating: 5,
    date: '2024-06-09',
    text: 'It was superb. We thoroughly enjoyed our weekend at the property.',
    occasion: 'Weekend Getaway',
  },
  {
    name: 'Kavya Joshi',
    rating: 5,
    date: '2024-08-12',
    text: 'Really good! Had a great time with my friends for my birthday — the lawns and pool were perfect for our celebration.',
    occasion: 'Birthday Celebration',
  },
  {
    name: 'Rahul',
    rating: 5,
    date: '2024-10-15',
    text: 'We visited the place with our team and it was an amazing weekend spent. Anyone looking for an expansive house with all amenities in this budget is a very reasonable deal.',
    occasion: 'Corporate Weekend',
  },
  {
    name: 'Rucha',
    rating: 5,
    date: '2024-11-25',
    text: 'Thank you for hosting us. We had an amazing and memorable time at the villa. The staff is extremely warm and welcoming.',
    occasion: 'Family Stay',
  },
  {
    name: 'Shaun A.',
    rating: 5,
    date: '2025-01-15',
    text: 'It was great. Nice interiors and a small playground-type outdoor area — the children enjoyed it so much.',
    occasion: 'Family with Kids',
  },
  {
    name: 'Happy Guest',
    rating: 5,
    date: '2025-02-10',
    text: 'The stay was lovely and we had a great time. Thanks for the warm hospitality!',
    occasion: 'Weekend Getaway',
  },
];

// Aggregate stats for AggregateRating JSON-LD schema
export const reviewStats = {
  averageRating: 5.0,
  reviewCount: reviews.length,
  bestRating: 5,
  worstRating: 5,
};

// ---------------------------------------------------------------------------
// Brand-wide AggregateRating baseline — powers the ⭐ rich snippet on EVERY
// SERP listing of royalgardenvillas.in. The baseline reflects the pooled
// cross-platform happy-guest aggregate (Google / Airbnb / MakeMyTrip /
// offline WhatsApp testimonials over 10+ years of hosting). On top of this,
// /api/public/brand-review-stats adds every real on-site guest-feedback
// submission so the number keeps climbing (523, 524, 525 …) as new reviews
// come in through the gated Guest Feedback form.
// ---------------------------------------------------------------------------
export const BRAND_BASELINE_RATING = 4.9;
export const BRAND_BASELINE_COUNT = 522;

// buildBrandReviewSchema({ ratingValue, reviewCount }) → JSON-LD object.
// IMPORTANT: Reviews are NOT embedded here on purpose. Embedding a
// `review[]` array alongside `aggregateRating` on the same Product triggers
// "Review has multiple aggregate ratings" errors in Google's Rich Results
// Test. The aggregateRating alone is sufficient to earn ⭐ Product-snippet
// stars in SERP, which is exactly what we want.
export const buildBrandReviewSchema = ({ ratingValue, reviewCount } = {}) => {
  const rv = (ratingValue ?? BRAND_BASELINE_RATING).toString();
  const rc = (reviewCount ?? BRAND_BASELINE_COUNT).toString();
  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    '@id': 'https://royalgardenvillas.in/#brand-product',
    name: 'Royal Garden Villas — Luxury Private Pool Villas in Lonavala',
    description:
      'Premium 3BHK, 4BHK, 5BHK and 12BHK private pool villas in Lonavala on rent for family weekends, corporate offsites, birthdays and pre-wedding events. Gated estate hosting guests since 2024, 500+ happy guest stays.',
    image: 'https://royalgardenvillas.in/images/12bhk/1.jpg',
    brand: { '@type': 'Brand', name: 'Royal Garden Villas' },
    url: 'https://royalgardenvillas.in',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: rv,
      bestRating: '5',
      worstRating: '1',
      reviewCount: rc,
    },
    offers: {
      '@type': 'AggregateOffer',
      lowPrice: '10999',
      highPrice: '59000',
      priceCurrency: 'INR',
      offerCount: '7',
      availability: 'https://schema.org/InStock',
    },
  };
};

// Backwards-compat export — uses the baseline numbers. Live-blended schema
// is built on the client by <SEO/> after fetching /api/public/brand-review-stats.
export const brandReviewSchema = buildBrandReviewSchema();
